export default {
  // API_ENDPOINT: 'http://localhost:8000/api',
  API_ENDPOINT: 'https://nameless-bayou-94377.herokuapp.com/api',
  TOKEN_KEY: 'idea-machine-client-auth-token',

}